import React, { useState } from 'react';
import './subscription.scss';
import { subscribeToEmailAlerts } from '../../api/api';
import { isValidEmail } from '../../util/helper';

// Assets
// ---------------------
import SubscribedImage from '../../assets/images/tick.svg';

export const Subscription = ({ label }) => {
  const [hasError, setError] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleChange = event => {
    if (event.target.value.trim() === '') {
      setError(false);
      setDisabled(true);
    }
    else {
      const isValid = !isValidEmail(event.target.value);
      if (hasError !== isValid || disabled !== isValid) {
        setError(isValid);
        setDisabled(isValid);
      }
    } 
    setEmail(event.target.value);
  };

  const handleSubscribe = async event => {
    const status = await subscribeToEmailAlerts(email);
    setSubscribed(status);
  }

  return (
    <div className={`subscription-component${hasError ? ' component-invalid': ''}`}>
      <span className="subscription-label">
        {label ? label : 'Enter to subscribe to announcements'}
      </span>
      <input
        type="text"
        name="email"
        id="email"
        aria-label="Type email"
        placeholder="Your email"
        onChange={handleChange}
        readOnly={subscribed}
        value={email}
      />
      {hasError ? <span className="subscription-error">Please enter a valid email address format</span> : null}
      {subscribed 
      ? 
        <div className='subscribed'>
          <div class="icon baseline">
            <img src={SubscribedImage} alt='Subscription successful' />
          </div>
          Subscribed
        </div>
      : 
        <button 
          className={hasError ? "margin-with-error" : "margin-without-error"}
          disabled={disabled}
          onClick={handleSubscribe}>
            Subscribe
        </button>
      }
    </div>
  );
};

Subscription.propTypes = {};